var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 314 280",
    style: {
      enableBackground: "new 0 0 314 280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#003CE6;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#FF3B00;}\n\t.st3{fill:url(#SVGID_00000107562734520385761130000014300347562524520870_);}\n\t.st4{fill:url(#SVGID_00000053509673726469990500000011390951466901509269_);}\n\t.st5{fill:#2D334D;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#2D334D;}\n\t.st7{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.1,113.5c30.4,0,55.1-25.4,55.1-56.7C110.1,25.4,85.5,0,55.1,0C24.6,0,0,25.4,0,56.7 C0,88.1,24.6,113.5,55.1,113.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.0525,
    y1: 279,
    x2: 55.0525,
    y2: 170.56,
    gradientTransform: "matrix(1 0 0 -1 0 279)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.097
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.1,108.4c30.4,0,55.1-24.3,55.1-54.2S85.5,0,55.1,0C24.6,0,0,24.3,0,54.2S24.6,108.4,55.1,108.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.1,97.8c23.3,0,42.3-19,42.3-42.5c0-23.5-18.9-42.5-42.3-42.5c-23.3,0-42.3,19-42.3,42.5 C12.8,78.8,31.7,97.8,55.1,97.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.4,113.5c30.7,0,55.6-25.4,55.6-56.7C314,25.4,289.1,0,258.4,0c-30.7,0-55.6,25.4-55.6,56.7 C202.9,88.1,227.7,113.5,258.4,113.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052077089006134928090000009380797144449954178_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.433,
    y1: 279,
    x2: 258.433,
    y2: 170.56,
    gradientTransform: "matrix(1 0 0 -1 0 279)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.097
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052077089006134928090000009380797144449954178_)"
    },
    d: "M258.4,108.4c30.7,0,55.6-24.3,55.6-54.2 S289.1,0,258.4,0c-30.7,0-55.6,24.3-55.6,54.2S227.7,108.4,258.4,108.4z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258.4,97.8c23.6,0,42.7-19,42.7-42.5c0-23.5-19.1-42.5-42.7-42.5c-23.6,0-42.7,19-42.7,42.5 C215.8,78.8,234.9,97.8,258.4,97.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157,279.1c30.7,0,55.6-25.4,55.6-56.7c0-31.3-24.9-56.7-55.6-56.7s-55.6,25.4-55.6,56.7 C101.4,253.7,126.3,279.1,157,279.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024707600058222581420000017746548475281837204_",
    gradientUnits: "userSpaceOnUse",
    x1: 157,
    y1: 113.395,
    x2: 157,
    y2: 4.954,
    gradientTransform: "matrix(1 0 0 -1 0 279)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.097
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024707600058222581420000017746548475281837204_)"
    },
    d: "M157,274c30.7,0,55.6-24.3,55.6-54.2 s-24.9-54.2-55.6-54.2s-55.6,24.3-55.6,54.2S126.3,274,157,274z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M157,263.4c23.6,0,42.7-19,42.7-42.5s-19.1-42.5-42.7-42.5s-42.7,19-42.7,42.5S133.4,263.4,157,263.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M133.5,50.7h47.6c1.1,0,2.1,0.9,2.1,2.1c0,1.1-0.9,2.1-2.1,2.1h-47.6c-1.1,0-2.1-0.9-2.1-2.1 C131.4,51.6,132.4,50.7,133.5,50.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M139.8,42.5l-8.9,9c-0.7,0.8-0.7,2,0,2.7c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.1,0.5,0.1,0.7,0.1 c0.2,0,0.5-0.1,0.7-0.1c0.2-0.1,0.4-0.2,0.6-0.4l8.9-9c0.4-0.4,0.6-0.8,0.6-1.4c0-0.5-0.2-1-0.6-1.4c-0.2-0.2-0.4-0.3-0.6-0.4 c-0.2-0.1-0.5-0.1-0.7-0.1c-0.2,0-0.5,0.1-0.7,0.1C140.2,42.1,139.9,42.3,139.8,42.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M142.5,60.4l-8.9-9c-0.2-0.2-0.4-0.3-0.6-0.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.2,0-0.5,0-0.7,0.1 c-0.2,0.1-0.4,0.2-0.6,0.4c-0.7,0.7-0.8,2,0,2.7l8.9,9c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.1,0.5,0.1,0.7,0.1c0.2,0,0.5,0,0.7-0.1 c0.2-0.1,0.4-0.2,0.6-0.4c0.4-0.4,0.6-0.8,0.6-1.4C143,61.3,142.8,60.8,142.5,60.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M111.8,162.7l-27.3-39c-0.7-0.9-0.4-2.2,0.5-2.9c0.9-0.7,2.2-0.4,2.9,0.5l27.3,39c0.7,0.9,0.4,2.2-0.5,2.9 C113.7,163.8,112.4,163.6,111.8,162.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M101.4,162.3l12.5,2.1c1,0.2,2-0.5,2.2-1.6c0-0.2,0-0.5,0-0.7s-0.2-0.5-0.3-0.7c-0.1-0.2-0.3-0.4-0.5-0.5 c-0.2-0.1-0.4-0.2-0.7-0.3l-12.5-2.1c-0.5-0.1-1,0-1.4,0.3s-0.7,0.7-0.8,1.2c0,0.2,0,0.5,0,0.7s0.2,0.5,0.3,0.7 c0.1,0.2,0.3,0.4,0.5,0.5C100.9,162.2,101.2,162.3,101.4,162.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.6,149.8l-2.3,12.5c0,0.2,0,0.5,0,0.7c0.1,0.2,0.2,0.5,0.3,0.7c0.1,0.2,0.3,0.4,0.5,0.5 c0.2,0.1,0.4,0.2,0.7,0.3c1,0.2,2-0.5,2.2-1.5l2.3-12.5c0-0.2,0-0.5,0-0.7c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.2-0.3-0.4-0.5-0.5 c-0.2-0.1-0.4-0.2-0.7-0.3c-0.5-0.1-1,0-1.4,0.3S114.7,149.3,114.6,149.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M230.8,123l-27.3,39c-0.7,0.9-0.4,2.2,0.5,2.9c0.9,0.7,2.2,0.4,2.9-0.5l27.3-39c0.7-0.9,0.4-2.2-0.5-2.9 C232.7,121.8,231.4,122.1,230.8,123z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.4,123.4l12.5-2.1c1-0.2,2,0.5,2.2,1.6c0,0.2,0,0.5,0,0.7c-0.1,0.2-0.2,0.5-0.3,0.7 c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.4,0.2-0.7,0.3l-12.5,2.1c-0.5,0.1-1,0-1.4-0.3s-0.7-0.7-0.8-1.2c0-0.2,0-0.5,0-0.7 c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.2,0.3-0.4,0.5-0.5C220,123.5,220.2,123.4,220.4,123.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233.6,135.9l-2.3-12.5c0-0.2,0-0.5,0-0.7c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.2,0.3-0.4,0.5-0.5 c0.2-0.1,0.4-0.2,0.7-0.3c1-0.2,2,0.5,2.2,1.5l2.3,12.5c0,0.2,0,0.5,0,0.7c-0.1,0.2-0.2,0.5-0.3,0.7s-0.3,0.4-0.5,0.5 c-0.2,0.1-0.4,0.2-0.7,0.3c-0.5,0.1-1,0-1.4-0.3C234,136.8,233.7,136.4,233.6,135.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M254.4,39.3c-1.5,0-2.7,0.3-3.4,0.5c0,0,0,0-0.1,0l-4.4,1.4c-5.2,1.6-8.7,6.4-8.7,11.8v9.3 c0,6.8,5.6,12.4,12.4,12.4h17.5c2.2,0,4.2-1.2,5.1-3.3c0.5-1.3,0.5-2.7-0.1-4c1.1-0.6,2-1.5,2.5-2.7c0.6-1.4,0.5-2.9-0.1-4.1h6.9 c2.9,0,5.3-2.4,5.3-5.3c0-2.9-2.4-5.3-5.3-5.3h-2.7l0.7-0.2c2.8-0.8,4.4-3.8,3.5-6.6c-0.8-2.8-3.8-4.4-6.6-3.5L262,44.1 c-0.1-0.3-0.3-0.7-0.5-1c-0.9-1.5-2.7-3.1-5.5-3.6C255.5,39.3,254.9,39.3,254.4,39.3z M278.7,42.9c0.7,0.1,1.3,0.6,1.5,1.3 c0.3,1-0.3,1.9-1.2,2.2L266.9,50l0.6,2v1.5H282c1,0,1.8,0.8,1.8,1.8S283,57,282,57h-11.6l-4.6-1.8c-0.7-0.3-1.4-0.4-2-0.4l-0.9-7.2 l15.2-4.6C278.2,42.8,278.4,42.8,278.7,42.9z M254.4,42.9c0.3,0,0.7,0,1,0.1c1.9,0.3,2.6,1.2,3.1,1.9c0.5,0.8,0.5,1.3,0.5,1.3 c0,0,0,0.1,0,0.1l1.5,11.4c0,0.1,0,0.1,0.1,0.2c0.2,0.9-0.3,1.8-1.3,2c-0.6,0.1-0.9,0.1-1.2-0.1c-0.3-0.2-0.7-0.5-0.9-1.3l-2.2-8.6 c-0.1-0.5-0.5-1-1-1.2c-0.5-0.2-1.1-0.2-1.5,0.1l-2.9,1.6c-0.9,0.5-1.2,1.5-0.7,2.4c0.5,0.9,1.5,1.2,2.4,0.7l0.9-0.5l1.7,6.5 c0,0.1,0,0.1,0.1,0.2c0.5,1.4,1.3,2.5,2.4,3.1c0.9,0.6,2,0.8,3.1,0.7c-0.6,0.5-1,1.2-1.3,1.9c-0.8,2-0.3,4.2,1.2,5.7h-9 c-4.9,0-8.8-3.9-8.8-8.8V53c0-3.9,2.5-7.3,6.2-8.4l4.4-1.3C252.4,43.1,253.4,42.9,254.4,42.9z M264,58.4c0.1,0,0.3,0,0.4,0.1 l6.6,2.6c0.9,0.4,1.4,1.3,1,2.3c-0.4,0.9-1.4,1.4-2.3,1l-6.6-2.6c-0.1,0-0.1-0.1-0.2-0.2C263.5,60.7,264,59.5,264,58.4z M262.9,65.6 c0.2,0,0.5,0,0.7,0.1l2.4,0.9l2.3,0.9l0.2,0.1c0.9,0.4,1.4,1.4,1,2.3c-0.3,0.7-0.9,1.1-1.5,1.1c0,0,0,0-0.1,0c-0.2,0-0.5,0-0.7-0.1 l-4.9-2c-0.9-0.4-1.4-1.4-1-2.3c0.2-0.5,0.5-0.8,0.9-0.9C262.4,65.7,262.7,65.6,262.9,65.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M53.2,27.4c-2.7,0-5,1.9-5.6,4.4c-0.7-0.3-1.4-0.5-2.2-0.5c-3.2,0-5.9,2.7-5.9,5.9v21.1l-1.7-1.7 c-2.3-2.3-6.1-2.3-8.4,0c-2.3,2.3-2.3,6.1,0,8.4l13.3,13.3c2.3,2.3,5.5,4.1,9.3,4.1h9.1c7.6,0,13.8-6.2,13.8-13.8V45.1 c0-3.2-2.7-5.9-5.9-5.9c-0.7,0-1.3,0.1-2,0.4v-2.3c0-3.2-2.7-5.9-5.9-5.9c-0.8,0-1.5,0.2-2.2,0.5C58.2,29.3,55.9,27.4,53.2,27.4z  M53.2,31.3c1.1,0,2,0.9,2,2v19.6h3.9V37.2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v15.7H67v-7.9c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v23.6 c0,5.4-4.4,9.8-9.8,9.8H52c-2.5,0-4.7-1.2-6.4-3L32.2,62.2c-0.8-0.8-0.8-2,0-2.8c0.8-0.8,2-0.8,2.8,0l5,5.1l3.4,3.4V37.2 c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v15.7h3.9V33.3C51.3,32.2,52.1,31.3,53.2,31.3z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M154.8,201.2c-2.2,0-4.1,1.1-5.2,2.9c-0.9-0.5-1.9-0.8-3-0.8c-3.4,0-6.1,2.8-6.1,6.1v7.5l-4.3,5.5 c-2.6,3.4-2.4,8.2,0.4,11.4l4.8,5.5c2.7,3.1,6.6,4.8,10.7,4.8H163c7.9,0,14.3-6.4,14.3-14.3v-18.4c0-3.4-2.8-6.1-6.1-6.1 c-1.1,0-2.1,0.3-3,0.8c-1.1-1.7-3-2.9-5.2-2.9c-1.1,0-2.1,0.3-3,0.8C158.9,202.3,157,201.2,154.8,201.2z M154.8,205.3 c1.2,0,2,0.9,2,2v6.1h4.1v-4.1c0-1.2,0.9-2,2-2s2,0.9,2,2v4.1h4.1v-2c0-1.2,0.9-2,2-2s2,0.9,2,2v18.4c0,5.7-4.5,10.2-10.2,10.2 h-10.8c-2.9,0-5.7-1.2-7.7-3.4l-4.8-5.5c-1.5-1.8-1.6-4.3-0.2-6.1l1-1.3v2.2h4.1v-16.3c0-1.2,0.9-2,2-2s2,0.9,2,2v4.1h4.1v-6.1 C152.7,206.2,153.6,205.3,154.8,205.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M140.3,32.1v-8.4h3.3c1.6,0,2.5,0.8,2.5,2.1c0,0.9-0.4,1.5-1,1.8c0.8,0.3,1.4,0.8,1.4,2c0,1.7-1.2,2.5-2.7,2.5 H140.3z M142.4,25.4V27h0.8c0.7,0,1-0.3,1-0.8c0-0.6-0.3-0.8-1-0.8H142.4z M144.4,29.4c0-0.5-0.3-1-1.2-1h-0.8v2h0.8 C144.1,30.5,144.4,30,144.4,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M152,23.7v1.8h-2.9v1.6h2.7v1.5h-2.7v1.7h2.9v1.8h-5v-8.4H152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M157.6,30.4h-2.8l-0.6,1.7H152l3.3-8.6h1.7l3.3,8.6h-2.2L157.6,30.4z M156.1,26.1l-0.8,2.6h1.7L156.1,26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.1,25.7v6.5H161v-6.5h-1.8v-1.9h5.7v1.9H163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M167.6,32.2c-0.8,0-1.8-0.1-2.3-0.2v-1.8c0.7,0.1,1.5,0.2,2.2,0.2c0.8,0,1.1-0.3,1.1-0.8c0-0.4-0.2-0.7-0.8-1 c-2-0.5-2.5-1.4-2.5-2.6c0-1.4,1.1-2.5,3-2.5c0.8,0,1.6,0.1,2,0.3v1.8c-0.7-0.2-1.4-0.3-2-0.3c-0.7,0-1,0.3-1,0.7 c0,0.4,0.2,0.6,1.1,0.9c1.8,0.6,2.3,1.5,2.3,2.6C170.7,31.2,169.6,32.2,167.6,32.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.5,151.7v-8.4h3.3c1.6,0,2.5,0.8,2.5,2.1c0,0.9-0.4,1.5-1,1.8c0.8,0.3,1.4,0.8,1.4,2c0,1.7-1.2,2.5-2.7,2.5 H43.5z M45.6,144.9v1.6h0.8c0.7,0,1-0.3,1-0.8c0-0.6-0.3-0.8-1-0.8H45.6z M47.5,149c0-0.5-0.3-1-1.2-1h-0.8v2h0.8 C47.2,150,47.5,149.5,47.5,149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M55.1,143.3v1.8h-2.9v1.6H55v1.5h-2.7v1.7h2.9v1.8h-5v-8.4H55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.7,150h-2.8l-0.6,1.7h-2.1l3.3-8.6h1.7l3.3,8.6h-2.2L60.7,150z M59.3,145.6l-0.8,2.6h1.7L59.3,145.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.3,145.2v6.5h-2.1v-6.5h-1.8v-1.9h5.7v1.9H66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.8,151.8c-0.8,0-1.8-0.1-2.3-0.2v-1.8c0.7,0.1,1.5,0.2,2.2,0.2c0.8,0,1.1-0.3,1.1-0.8c0-0.4-0.2-0.7-0.8-1 c-2-0.5-2.5-1.4-2.5-2.6c0-1.4,1.1-2.5,3-2.5c0.8,0,1.6,0.1,2,0.3v1.8c-0.7-0.2-1.4-0.3-2-0.3c-0.7,0-1,0.3-1,0.7 c0,0.4,0.2,0.6,1.1,0.9c1.8,0.6,2.3,1.5,2.3,2.6C73.8,150.7,72.7,151.8,70.8,151.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M244.8,151.7v-8.4h3.3c1.6,0,2.5,0.8,2.5,2.1c0,0.9-0.4,1.5-1,1.8c0.8,0.3,1.4,0.8,1.4,2 c0,1.7-1.2,2.5-2.7,2.5H244.8z M246.9,144.9v1.6h0.8c0.7,0,1-0.3,1-0.8c0-0.6-0.3-0.8-1-0.8H246.9z M248.8,148.9c0-0.5-0.3-1-1.2-1 h-0.8v2h0.8C248.5,150,248.8,149.5,248.8,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M256.5,143.3v1.8h-2.9v1.6h2.7v1.5h-2.7v1.7h2.9v1.8h-5v-8.4H256.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M262,149.9h-2.8l-0.6,1.7h-2.1l3.3-8.6h1.7l3.3,8.6h-2.2L262,149.9z M260.6,145.6l-0.8,2.6h1.7L260.6,145.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M267.6,145.2v6.5h-2.1v-6.5h-1.8v-1.9h5.7v1.9H267.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.1,151.8c-0.8,0-1.8-0.1-2.3-0.2v-1.8c0.7,0.1,1.5,0.2,2.2,0.2c0.8,0,1.1-0.3,1.1-0.8c0-0.4-0.2-0.7-0.8-1 c-2-0.5-2.5-1.4-2.5-2.6c0-1.4,1.1-2.5,3-2.5c0.8,0,1.6,0.1,2,0.3v1.8c-0.7-0.2-1.4-0.3-2-0.3c-0.7,0-1,0.3-1,0.7 c0,0.4,0.2,0.6,1.1,0.9c1.8,0.6,2.3,1.5,2.3,2.6C275.1,150.7,274,151.8,272.1,151.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/Rules.55e39cc48e47ef5a6cd7d0c0ed8e24c6.svg";
export { ForwardRef as ReactComponent };